import { Route, Routes } from '@angular/router';
import { LoginShellComponent } from './login-shell.component';
import { MaintenanceInProgressGuard } from '@shared/guards/maintenanceInProgress.guard';

/**
 * Provides helper methods to create routes.
 */
export class LoginShell {
  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  public static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: LoginShellComponent,
      children: routes,
      canActivate: [MaintenanceInProgressGuard],
    };
  }
}
